import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger);
export default function () {
  const sections = document.querySelectorAll('.news-section')

  sections.forEach(section => {
    const items = section.querySelectorAll('.news-item');

    ScrollTrigger.matchMedia({
      "(max-width: 1024px)": function () {
        items.forEach(item => {
          ScrollTrigger.create({
            trigger: item,
            start: 'top bottom-=20%',
            end: 'top bottom-=20%',
            once: true,
            onEnter: () => showItems([item]),
          })
        })
      },

      "(min-width: 1025px)": function () {
        ScrollTrigger.create({
          trigger: section.querySelector('.news-grid'),
          start: 'top bottom-=20%',
          end: 'top bottom-=20%',
          once: true,
          onEnter: () => showItems(items),
        })
      },
    });

    function showItems(arr) {
      arr.forEach((item, index) => {
        const time = item.querySelector('.news-item__time')
        const title = item.querySelector('.news-item__title')
        const arrow = item.querySelector('.news-item__arrow')

        const delayIndex = index * 0.25

        gsap
          .timeline({
            delay: delayIndex,
            onComplete: () => {
              item.classList.add('show')
            },
          })
          .call(() => gsap.effects.split(time), null, '')
          .call(() => gsap.effects.fade(title), null, '>0.2')
          .call(() => gsap.effects.animateMiniArrow(arrow), null, '>0.2')
      })
    }
  })
}
